const SEO_CONFIG = {
  '/': {
    title: 'WANDEROBE | Curated Fashion Delivery to Your Hotel in NYC',
    description: 'Travel light, dress meaningfully. WANDEROBE delivers curated fashion from local NYC designers to your hotel so you can explore the city in style.'
  },
  '/about': {
    title: 'About WANDEROBE | Redefining Fashion for Travelers',
    description: 'WANDEROBE connects travelers with locally inspired fashion from emerging designers. Discover our mission to simplify style and elevate travel.'
  },
  '/browse': {
    title: 'Browse Curated Travel Looks | WANDEROBE Hotel Wardrobe Delivery',
    description: 'Explore our curated clothing collection for your NYC stay. Find stylish pieces from local designers, delivered straight to your hotel room.'
  },
  '/how-it-works': {
    title: 'How WANDEROBE Works | Hotel Fashion Delivery Made Easy',
    description: 'Learn how to reserve your wardrobe, try on outfits at your hotel, and travel light with WANDEROBE’s seamless clothing delivery service.'
  },
  '/bag': {
    title: 'Your WANDEROBE Bag | Review and Reserve Your Wardrobe',
    description: 'Ready to turn heads? Review the pieces you\'ve selected and prepare to travel in effortless style with WANDEROBE’s hotel delivery service.'
  },
  '/closet': {
    title: 'Your WANDEROBE Closet | Track Your Wardrobe Selections',
    description: "Access and manage the curated fashion looks you've chosen for your trip. Travel smart with your WANDEROBE digital closet."
  },
  '/privacy-policy': {
    title: 'Privacy Policy | WANDEROBE',
    description: 'Learn how WANDEROBE collects, uses, and protects your data when you use our hotel fashion delivery service.'
  },
  '/terms-and-condition': {
    title: 'Terms & Conditions | WANDEROBE Hotel Fashion Service',
    description: 'Review the terms and conditions for using WANDEROBE’s curated clothing delivery service for hotel guests in NYC.'
  },
  '/customer-support': {
    title: 'Customer Support | Get Help with Your WANDEROBE Order',
    description: 'Need help? Contact WANDEROBE\'s support team for assistance with orders, delivery, or wardrobe selections during your hotel stay.'
  },
};

export default SEO_CONFIG; 